<template>
  <b-container fluid>
    <main-modal id="folderDetailsModal" size="lg">
      <template v-slot:header>
        <h4 class="font-weight-bold" v-if="typeOfModal == 'add'" ><span class="text-warning" >Add: </span> Folder</h4>
        <h4 class="font-weight-bold" v-else><span class="text-info" >Edit: </span> Folder</h4>
      </template>
      <template v-slot:body>
        <folder-details
          @addFolder="addFolder"
          @editFolder="editFolder"
          :requestLoading="requestLoading"
          :typeOfModal="typeOfModal"
          :folderDetails="folderDetails"
        />
      </template>
    </main-modal>

    <b-row>
      <div v-if="arrangeMode" class="position-absolute arrange-overlay">
        <p class="position-absolute arrange-text text-warning">You are in arrange mode now, specify the order of the selected
          item</p>
      </div>

      <b-col lg="12" class="mb-2 d-flex justify-content-between align-items-center">
        <h3>
          <div @click="$router.go(-1)" class="btn bg-white add_button" >
            <i class="fa fa-chevron-left"></i>
          </div>
          Folders
        </h3>
        <div class="d-flex justify-content-between gap-20">
          <b-button @click="arrangeMode = !arrangeMode" variant="dark" class="add_button text-white">
            <span v-if="!arrangeMode">Arrange<i class="fas fa-arrow-down-arrow-up"></i></span>
            <span v-else>Save</span>
          </b-button>
          <b-button @click="openPopup" variant="warning" class="add_button text-white">
          Add Folder<i class="las la-plus ml-3"></i></b-button>
        </div>
      </b-col>

      <b-col lg="12">
        <main-table
          :fields="columns"
          class="mb-0 table-borderless"
          @sortChanged="sortChanged"
          :list_url="'folders'"
          :customFilter="{ type: type }"
          :reloadData="reloadTable"
          :service_type="'ticket'"
          :arrangeMode="arrangeMode"
        >
        </main-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import folderDetails from '../components/folderDetails'
import foldersServices from '../services/folders.services'

export default {
  props: {
    type: {
      type: String
    }
  },
  components: { folderDetails },
  data () {
    return {
      reloadTable: false,
      requestLoading: false,
      columns: [
        { label: '#', key: '#', class: 'text-center', type: 'sort' },
        { label: 'Folder Name', key: 'name', class: 'text-left' },
        {
          label: 'Actions',
          key: 'actions',
          class: 'text-left',
          type: 'actions',
          actions: [
            {
              icon: 'las la-pen',
              color: 'info',
              text: 'Edit',
              actionName: 'showFolderToEdit',
              actionParams: 'fullObj'
            },
            {
              icon: 'las la-trash-alt',
              color: 'danger',
              text: 'Delete',
              showAlert: true,
              actionHeader: 'Delete',
              titleHeader: 'Folder',
              textContent: 'name',
              url: 'folders'
            }
          ]
        }
      ],
      typeOfModal: 'add',
      folderDetails: {},
      arrangeMode: false
    }
  },
  methods: {
    sortChanged (key) {
      console.log(key)
    },
    openPopup () {
      debugger
      this.typeOfModal = 'add'
      this.folderDetails = false
      this.$bvModal.show('folderDetailsModal')
    },
    showFolderToEdit (obj) {
      this.typeOfModal = 'edit'
      this.folderDetails = obj
      this.$bvModal.show('folderDetailsModal')
    },

    addFolder (data) {
      this.requestLoading = true
      foldersServices.addFolder({ ...data, type: this.type }).then(res => {
        core.showSnackbar('success', res.data.message)
        this.$bvModal.hide('folderDetailsModal')
        this.reloadTable = true
        setTimeout(() => { this.reloadTable = false }, 1000)
      }).finally(() => {
        this.requestLoading = false
      })
    },
    editFolder (data) {
      debugger
      this.requestLoading = true
      foldersServices.editFolder(data.id, { ...data, type: this.type }).then(res => {
        core.showSnackbar('success', res.data.message)
        this.$bvModal.hide('folderDetailsModal')
        this.reloadTable = true
        setTimeout(() => { this.reloadTable = false }, 1000)
      }).finally(() => {
        this.requestLoading = false
      })
    }
  },
  created () {
    this.$root.$on('showFolderToEdit', this.showFolderToEdit)
  },
  beforeDestroy () {
    this.$root.$off('showFolderToEdit')
  },
  mounted () {
    core.index()
  }
}
</script>
